import React from 'react'
import Link from 'gatsby-link'

import Sectiontitle from '../components/sectionTitle'

import '../sass/partials/activityblock.scss'

class ActivityBlock extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return ( 
            <div className="activity-block">
                <div className="block-row">
                    <div className="block-row__grid block-row__text">
                        <Sectiontitle title="Nature Walks" color="black" />
                        <div className="rc-copy small">
                            Nature walks are exciting for kids. There is so much to see and explore along the walks. So much to touch, smell and feel. 
                            Along the way gathering and picking up thing, collecting leaves, pine cones, twigs and learning about them. Tracking animal footprints, looking at different insects.
                        </div>
                    </div>
                    <div className="block-row__grid block-row__img nature"></div>
                </div>
                <div className="block-row">
                    <div className="block-row__grid block-row__text block-row__grid--mobile">
                        <Sectiontitle title="Activities around the home" color="black" />
                        <div className="rc-copy small">
                        Keeping children busy with painting and colouring, also art and craft activities for learning. Learning about the garden, plants, trees, etc. Potting new plants and seeds, watching them grow. Playing with sand, making sand castles. Making birthday and special days' cards.
                        </div>
                    </div>
                    <div className="block-row__grid block-row__img childart"></div>
                    <div className="block-row__grid block-row__text block-row__grid--desktop">
                        <Sectiontitle title="Activities around the home" color="black" />
                        <div className="rc-copy small">
                            Keeping children busy with painting and colouring, also art and craft activities for learning. Learning about the garden, plants, trees, etc. Potting new plants and seeds, watching them grow. Playing with sand, making sand castles. Making birthday and special days' cards. 
                        </div>
                    </div>
                </div>
                <div className="block-row">
                    <div className="block-row__grid block-row__text">
                        <Sectiontitle title="Visits to local child groups" color="black" />
                        <div className="rc-copy small">
                            Learning to interact with other children in play and activities. Learning to share equipment and working together as groups. Keeping the youngsters happy and fit by playing games.
                        </div>
                    </div>
                    <div className="block-row__grid block-row__img childgroup"></div>
                </div>
            </div>
        );
    }
}

export default ActivityBlock



// WEBPACK FOOTER //
// ./src/components/activityBlock.js